import { useEffect, useRef } from 'react';
// import * as THREE from 'three';
// import { ARButton } from 'three/examples/jsm/webxr/ARButton';

export default function ARView() {
  const containerRef = useRef();

  // useEffect(() => {
  //   let renderer, scene, camera, reticle, hitTestSource = null, hitTestSourceRequested = false;
  //   let modelPlaced = false;

  //   // Initialize Renderer
  //   renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  //   renderer.setSize(window.innerWidth, window.innerHeight);
  //   renderer.xr.enabled = true;

  //   containerRef.current.appendChild(renderer.domElement);

  //   // Scene & Camera 
  //   scene = new THREE.Scene();
  //   camera = new THREE.PerspectiveCamera();

  //   // Lighting
  //   const light = new THREE.HemisphereLight(0xffffff, 0xbbbbff, 1);
  //   scene.add(light);

  //   // Reticle (Target indicator)
  //   const reticleGeometry = new THREE.RingGeometry(0.05, 0.06, 32).rotateX(-Math.PI / 2);
  //   const reticleMaterial = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
  //   reticle = new THREE.Mesh(reticleGeometry, reticleMaterial);
  //   reticle.matrixAutoUpdate = false;
  //   reticle.visible = false;
  //   scene.add(reticle);

  //   // Tap to Place Model
  //   const controller = renderer.xr.getController(0);
  //   controller.addEventListener('select', () => {
  //       const geometry = new THREE.BoxGeometry(0.1, 0.1, 0.1);
  //       const material = new THREE.MeshStandardMaterial({ color: 0x0077ff });
  //       const cube = new THREE.Mesh(geometry, material);
      
  //       // Try fixed position to test if the tap works
  //       cube.position.set(0, 0, -0.5); 
  //       scene.add(cube);
  //   });
      
  //   scene.add(controller);

  //   // AR Button 
  //   document.body.appendChild(
  //     ARButton.createButton(renderer, {
  //       requiredFeatures: ['hit-test'],
  //     })
  //   );

  //   // Render Loop with Hit Test 
  //   renderer.setAnimationLoop((timestamp, frame) => {
  //     if (frame) {
  //       const referenceSpace = renderer.xr.getReferenceSpace();
  //       const session = renderer.xr.getSession();

  //       if (!hitTestSourceRequested) {
  //         session.requestReferenceSpace('viewer').then((refSpace) => {
  //           session.requestHitTestSource({ space: refSpace }).then((source) => {
  //             hitTestSource = source;
  //           });
  //         });

  //         session.addEventListener('end', () => {
  //           hitTestSourceRequested = false;
  //           hitTestSource = null;
  //         });

  //         hitTestSourceRequested = true;
  //       }

  //       if (hitTestSource && referenceSpace) {
  //         const hitTestResults = frame.getHitTestResults(hitTestSource);
  //         if (hitTestResults.length > 0) {
  //           const hit = hitTestResults[0];
  //           const pose = hit.getPose(referenceSpace);
  //           reticle.visible = !modelPlaced;
  //           reticle.matrix.fromArray(pose.transform.matrix);
  //         }
  //       }
  //     }

  //     renderer.render(scene, camera);
  //   });

  //   return () => {
  //     renderer.setAnimationLoop(null);
  //     renderer.dispose();
  //   };
  // }, []);

  return <div ref={containerRef} />;
}
